<template>
  <div class="home">
    <Navbar />
    <DashBoard TIME="TOÀN BỘ"/>
    <vue-headful title="REPORT ALL" />
  </div>
</template>

<script>
// @ is an alias to /src
import DashBoard from "@/components/DashBoard.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "Home",
  components: {
    DashBoard,
    Navbar,
  },
};
</script>
<style>
body {
  background-color: white !important;
}
.vm-progress-bar__striped {
  text-align: left !important;
}
.vm-progress-bar__innerText {
  color: rgba(0, 0, 0, 0.65) !important;
  /* color:red!important; */
}
.footer {
  color: black !important;
}
</style>